/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const ACKNOWLEDGE_STORE_INSIGHT = gql`
  mutation AcknowledgeStoreInsight($id: ID!) {
    acknowledgeStoreInsight(storeInsightId: $id)
  }
`
